/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_GeneratingInputs */



/**
* | output |
* | --- |
* | "Wundo is writing your report…" |
*
* @param {Meeting_Report_GeneratingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_generating = /** @type {((inputs?: Meeting_Report_GeneratingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_GeneratingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft je verslag…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rédige votre compte rendu…")
	return /** @type {LocalizedString} */ ("Wundo is writing your report…")
});